import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.0833 6.41675H2.91667C2.27233 6.41675 1.75 6.93908 1.75 7.58341V11.6667C1.75 12.3111 2.27233 12.8334 2.91667 12.8334H11.0833C11.7277 12.8334 12.25 12.3111 12.25 11.6667V7.58341C12.25 6.93908 11.7277 6.41675 11.0833 6.41675Z"
        stroke="#3B3B3B"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.0835 6.41675V4.08341C4.0835 3.30987 4.39079 2.568 4.93777 2.02102C5.48475 1.47404 6.22661 1.16675 7.00016 1.16675C7.77371 1.16675 8.51558 1.47404 9.06256 2.02102"
        stroke="#3B3B3B"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 8.75L7 10.2813"
        stroke="#3B3B3B"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </Svg>
  );
};

export default Icon;
